import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const MicrosoftCallback: React.FC = () => {
    useEffect(() => {
        // Parse URL parameters from both query and fragment
        const urlParams = new URLSearchParams(window.location.search);
        const fragmentParams = new URLSearchParams(window.location.hash.substring(1));
        
        // Check both query and fragment for parameters
        const code = urlParams.get('code') || fragmentParams.get('code');
        const error = urlParams.get('error') || fragmentParams.get('error');
        const errorDescription = urlParams.get('error_description') || fragmentParams.get('error_description');
        const state = urlParams.get('state') || fragmentParams.get('state');

        console.log('Microsoft callback - URL search:', window.location.search);
        console.log('Microsoft callback - URL hash:', window.location.hash);
        console.log('Microsoft callback - Code:', code);
        console.log('Microsoft callback - Error:', error);

        if (error) {
            // Send error to parent window
            window.opener?.postMessage({
                type: 'MICROSOFT_SIGN_IN_ERROR',
                error: error,
                errorDescription: errorDescription
            }, window.location.origin);
        } else if (code) {
            // Send success with authorization code to parent window
            window.opener?.postMessage({
                type: 'MICROSOFT_SIGN_IN_SUCCESS',
                code: code,
                state: state
            }, window.location.origin);
        } else {
            // No code or error - something went wrong
            window.opener?.postMessage({
                type: 'MICROSOFT_SIGN_IN_ERROR',
                error: 'No authorization code received'
            }, window.location.origin);
        }

        // Close the popup
        window.close();
    }, []);

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            height="100vh"
            gap={2}
        >
            <CircularProgress />
            <Typography variant="h6">Processing Microsoft Sign-In...</Typography>
            <Typography color="text.secondary">This window will close automatically.</Typography>
        </Box>
    );
};

export default MicrosoftCallback;